"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LftAvatar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var S = __importStar(require("./LftAvatar.styles"));
var LftAvatar = function (_a) {
    var ariaDescribed = _a.ariaDescribed, ariaLabel = _a.ariaLabel, bgColor = _a.bgColor, description = _a.description, id = _a.id, _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.tabIndex, tabIndex = _c === void 0 ? 0 : _c, url = _a.url, lftClick = _a.lftClick;
    var _d = (0, react_1.useState)(null), abreviation = _d[0], setAbreviation = _d[1];
    (0, react_1.useEffect)(function () {
        if (description) {
            var wordsArray = description.trim().split(' ');
            if (wordsArray.length <= 1) {
                setAbreviation(wordsArray[0].substring(0, 2).toUpperCase());
            }
            else {
                var firstWord = wordsArray[0];
                var lastWord = wordsArray[wordsArray.length - 1];
                setAbreviation(firstWord[0] + lastWord[0]);
            }
        }
    }, [description]);
    var _handleClick = function (e) {
        lftClick && lftClick(e);
    };
    if (lftClick) {
        return ((0, jsx_runtime_1.jsx)(S.AvatarButton, __assign({ "aria-label": ariaLabel ? ariaLabel : description, bgColor: bgColor, "data-lift": "lft-avatar", id: id, size: size, onClick: _handleClick, tabIndex: tabIndex, role: "button" }, { children: !!url ?
                (0, jsx_runtime_1.jsx)(S.AvatarImgStyled, { "aria-hidden": true, src: url }, void 0) :
                (0, jsx_runtime_1.jsxs)(S.AvatarSpan, __assign({ "aria-hidden": true, bgColor: bgColor, size: size }, { children: [" ", !!abreviation && abreviation, " "] }), void 0) }), void 0));
    }
    else {
        return ((0, jsx_runtime_1.jsx)(S.AvatarFigure, __assign({ "aria-hidden": true, bgColor: bgColor, "data-lift": "lft-avatar", id: id, size: size, tabIndex: -1, role: "figure" }, { children: !!url ?
                (0, jsx_runtime_1.jsx)(S.AvatarImgStyled, { alt: description, src: url }, void 0) :
                (0, jsx_runtime_1.jsx)(S.AvatarFigCaption, __assign({ alt: description, "aria-describedby": ariaDescribed, "aria-label": ariaLabel ? ariaLabel : description, bgColor: bgColor, size: size }, { children: !!abreviation && abreviation }), void 0) }), void 0));
    }
};
exports.LftAvatar = LftAvatar;
exports.default = exports.LftAvatar;
